import { render, staticRenderFns } from "./ProgramsList.vue?vue&type=template&id=07059e04&"
import script from "./ProgramsList.vue?vue&type=script&lang=js&"
export * from "./ProgramsList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/programs.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports